"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var CartItemQty = /** @class */ (function (_super) {
    __extends(CartItemQty, _super);
    function CartItemQty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartItemQty.prototype.render = function () {
        var _this = this;
        var _a = this.props, max = _a.max, quantity = _a.quantity, isOutofStock = _a.isOutofStock;
        var decreaseBtnExtraClasses = quantity <= 1 ? " opacity-50 pointer-events-none" : "";
        var increaseBtnExtraClasses = quantity >= max ? " opacity-50 pointer-events-none" : "";
        return (React.createElement("div", { className: "flex items-center justify-center text-blue-grey " + (this.props.className ? " " + this.props.className : "") },
            React.createElement("button", { type: "button", className: "w-1/5 flex items-center justify-center focus:outline-none" + decreaseBtnExtraClasses, onClick: function () { return _this.props.handleClick("-"); }, title: "Decrease quantity", "aria-label": "Decrease quantity" },
                React.createElement(Snippets.Svg, { name: "minus", width: 16, className: "block" })),
            React.createElement("input", { className: "text-center text-base font-semibold w-3/5 text-midnight font-medium appearance-none border-none outline-none bg-transparent focus:outline-none", type: "text", value: isOutofStock ? 0 : quantity, min: 0, max: max || null, pattern: "[0-9]*", readOnly: true }),
            React.createElement("button", { type: "button", className: "w-1/5 flex items-center justify-center focus:outline-none" + increaseBtnExtraClasses, onClick: function () {
                    _this.props.handleClick("+");
                }, title: "Increase quantity", "aria-label": "Increase quantity" },
                React.createElement(Snippets.Svg, { name: "plus", width: 16, className: "block" }))));
    };
    return CartItemQty;
}(React.PureComponent));
exports.CartItemQty = CartItemQty;
